<template>
  <div class="entities-page">
    <section class="page-hero">
      <div class="container page-hero__content">
        <span class="page-kicker">Cobro del beneficio</span>
        <h1>Entidades autorizadas</h1>
        <p style="color: white;">
          Consulta los puntos habilitados para el pago del Bono Juancito Pinto
          en cada departamento del país.
        </p>
      </div>
    </section>

    <section class="entities-content" aria-labelledby="entities-title">
      <div class="container">
        <header class="content-heading">
          <div>
            <span class="page-kicker">Cobertura nacional</span>
            <h2 id="entities-title">Selecciona tu departamento</h2>
          </div>
          <p style="color: white;">Haz clic sobre una tarjeta para ampliar la información oficial.</p>
        </header>

        <div class="entities-grid">
          <button
            v-for="department in departments"
            :key="department.name"
            type="button"
            class="entity-card"
            :aria-label="`Ampliar información de ${department.name}`"
            @click="zoomImage(department.src)"
          >
            <span class="entity-card__label">{{ department.name }}</span>
            <img
              :src="department.src"
              class="department-image"
              :alt="`Entidades autorizadas en ${department.name}`"
              loading="lazy"
              decoding="async"
            />
            <span class="entity-card__action">
              Ampliar <i class="bx bx-expand-alt"></i>
            </span>
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { getCurrentInstance } from "vue";

const { proxy } = getCurrentInstance();
const departments = [
  { name: "La Paz", src: "depto/LA PAZ.jpg" },
  { name: "Tarija", src: "depto/TARIJA.jpg" },
  { name: "Santa Cruz", src: "depto/SANTA CRUZ.jpg" },
  { name: "Chuquisaca", src: "depto/CHUQUISACA.jpg" },
  { name: "Oruro", src: "depto/ORURO.jpg" },
  { name: "Potosí", src: "depto/POTOSI.jpg" },
  { name: "Cochabamba", src: "depto/COCHABAMBA.jpg" },
  { name: "Beni", src: "depto/BENI.jpg" },
  { name: "Pando", src: "depto/PANDO.jpg" },
];

const zoomImage = (src) => {
  if (proxy && proxy.$viewerApi) proxy.$viewerApi({ images: [src] });
};
</script>

<style scoped>
.page-hero {
  position: relative;
  min-height: 390px;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(197, 167, 70, 0.08), rgba(6, 47, 54, 0.16));
}

.page-hero::after {
  position: absolute;
  top: -16rem;
  right: -8rem;
  width: 36rem;
  height: 36rem;
  content: "";
  border: 1px solid rgba(6, 47, 54, 0.18);
  border-radius: 50%;
}

.page-hero__content {
  position: relative;
  z-index: 1;
  display: flex;
  min-height: 390px;
  flex-direction: column;
  justify-content: center;
  padding-top: 3rem;
  padding-bottom: 3rem;
}

.page-kicker {
  color: #ffffff;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.15em;
  text-transform: uppercase;
}

.page-hero h1 {
  max-width: 900px;
  margin: 0.55rem 0 0;
  color: var(--bjp-petrol-950);
  font-size: clamp(3rem, 7vw, 5.6rem);
  font-weight: 850;
  letter-spacing: -0.06em;
  line-height: 0.98;
}

.page-hero p {
  max-width: 680px;
  margin: 1.2rem 0 0;
  color: #294d4f;
  line-height: 1.75;
}

.entities-content {
  padding: clamp(4rem, 7vw, 6.5rem) 0;
  background: linear-gradient(180deg, rgba(91, 69, 20, 0.14), rgba(6, 47, 54, 0.2));
}

.content-heading {
  display: grid;
  grid-template-columns: 1fr minmax(260px, 430px);
  align-items: end;
  margin-bottom: 2rem;
  gap: 2rem;
}

.content-heading h2 {
  margin: 0.55rem 0 0;
  color: var(--bjp-petrol-950);
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 800;
  letter-spacing: -0.045em;
}

.content-heading > p {
  margin: 0;
  color: #315456;
  line-height: 1.7;
}

.entities-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1.1rem;
}

.entity-card {
  position: relative;
  display: flex;
  min-width: 0;
  flex-direction: column;
  padding: 0;
  overflow: hidden;
  text-align: left;
  border: 1px solid rgba(230, 203, 114, 0.24);
  border-radius: 22px;
  background: rgba(6, 47, 54, 0.82);
  box-shadow: 0 18px 40px rgba(37, 41, 31, 0.12);
  cursor: zoom-in;
  transition: transform 0.25s ease, border-color 0.25s ease,
    box-shadow 0.25s ease;
}

.entity-card:hover,
.entity-card:focus-visible {
  border-color: rgba(230, 203, 114, 0.5);
  box-shadow: 0 24px 48px rgba(37, 41, 31, 0.2);
  outline: none;
  transform: translateY(-6px);
}

.entity-card__label {
  padding: 1rem 1.1rem 0.8rem;
  color: #ffffff;
  font-size: 0.92rem;
  font-weight: 750;
}

.department-image {
  display: block;
  width: calc(100% - 1rem);
  height: auto;
  margin: 0 0.5rem;
  border-radius: 14px;
}

.entity-card__action {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0.8rem 1rem 0.9rem;
  color: #ffffff;
  font-size: 0.72rem;
  font-weight: 700;
  gap: 0.35rem;
}

@media (max-width: 991px) {
  .entities-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 767px) {
  .page-hero,
  .page-hero__content {
    min-height: 310px;
  }
  .content-heading {
    grid-template-columns: 1fr;
    align-items: start;
    gap: 1rem;
  }
}

@media (max-width: 575px) {
  .entities-grid {
    grid-template-columns: 1fr;
  }
}
</style>
